import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import EnergyCell from "../../../components/StaticDetailList/EnergyCell";
import NumberUtil from "../../../services/NumberUtil";
import ButtonCell from "@isceco/widget-library2/basic-elements/List/cell/ButtonCell";

export default class UebersichtMonitoringColumns {

  static getGpColumns(downloadCallback) {
    return [
      UebersichtMonitoringColumns.START_ENDE_COLUMN(),
      UebersichtMonitoringColumns.GP_KONTINGENT_COLUMN(),
      UebersichtMonitoringColumns.WEITERGABE_COLUMN(),
      UebersichtMonitoringColumns.GP_VERBRAUCH_COLUMN(),
      UebersichtMonitoringColumns.DOWNLOAD_COLUMN(downloadCallback)
    ]
  }

  static getOstralColumns() {
    return [
      UebersichtMonitoringColumns.START_ENDE_COLUMN(),
      UebersichtMonitoringColumns.PENDENTE_VNB_COLUMN(),
      UebersichtMonitoringColumns.UEBERSCHRITTENE_VNB_COLUMN(),
      UebersichtMonitoringColumns.KONTINGENT_COLUMN(),
      UebersichtMonitoringColumns.VERBRAUCH_COLUMN()
    ]
  }

  static getCurrentPeriodeVariant() {
    return {
      get(row) {
        const start = new Date(row.start), ende = new Date(row.ende), jetzt = new Date()
        jetzt.setUTCHours(0, 0, 0, 0)
        return start <= jetzt && jetzt <= ende ? 'success' : ''
      }
    }
  }

  static START_ENDE_COLUMN() {
    return new StringColumn({
      key: 'startEnde',
      text: 'verordnungMonitoring.uebersicht.perioden.header.startEnde',
      sortable: true
    })
  }

  static PENDENTE_VNB_COLUMN() {
    return new StringColumn({
      key: 'anzahlPendent',
      text: 'verordnungMonitoring.uebersicht.perioden.header.pendenteVnb',
      align: 'right',
      sortable: true
    })
  }

  static UEBERSCHRITTENE_VNB_COLUMN() {
    return new StringColumn({
      key: 'anzahlUeberschritten',
      text: 'verordnungMonitoring.uebersicht.perioden.header.ueberschritteneVnb',
      align: 'right',
      sortable: true
    })
  }

  static KONTINGENT_COLUMN() {
    return new GenericColumn({
      key: 'kontingent',
      text: 'verordnungMonitoring.uebersicht.perioden.header.kontingent',
      align: 'right',
      cell: new EnergyCell(),
      sortable: true
    })
  }

  static GP_KONTINGENT_COLUMN() {
    return new GenericColumn({
      key: 'kontingent',
      text: 'verordnungMonitoring.uebersicht.perioden.header.kontingent.gp',
      align: 'right',
      cell: new EnergyCell(),
      sortable: true
    })
  }

  static WEITERGABE_COLUMN() {
    return new StringColumn({
      key: 'weitergabe',
      text: 'verordnungMonitoring.uebersicht.perioden.header.weitergabe',
      sortable: true
    })
  }

  static VERBRAUCH_COLUMN() {
    return new GenericColumn({
      key: 'verbrauch',
      text: 'verordnungMonitoring.uebersicht.perioden.header.verbrauch',
      align: 'right',
      cell: new EnergyCell(),
      sortable: true
    })
  }

  static GP_VERBRAUCH_COLUMN() {
    return new GenericColumn({
      key: 'verbrauch',
      text: 'verordnungMonitoring.uebersicht.perioden.header.verbrauch.gp',
      align: 'right',
      cell: {
        render(i18n, cell, row) {
          const verbrauch = Number(row.verbrauch)
          const anteil = Number(row.anteil)
          if (isNaN(verbrauch) || isNaN(anteil)) {
            return cell
          }
          return i18n.translate('verordnungMonitoring.uebersicht.perioden.verbrauch.gp', {
            verbrauch: NumberUtil.format(verbrauch, 2),
            anteil: anteil
          })
        }
      },
      sortable: true
    })
  }

  static DOWNLOAD_COLUMN(callback) {
    return new GenericColumn({
      key: 'download',
      weight: 0.5,
      text: 'verordnungMonitoring.uebersicht.perioden.header.download',
      cell: new ButtonCell({
        icon: 'file pdf outline',
        text: 'verordnungMonitoring.uebersicht.perioden.download',
        variant: 'tertiary',
        disabled: row => !row.kontingentId,
        callback
      }),
      sortable: false
    })
  }
}
